import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { AUTH_COLORS, AUTH_FONT } from "../../config/authConstants";

function AuthPrimaryButton(props) {
  var children = props.children;
  var type = props.type || "button";
  var disabled = props.disabled;
  var loading = props.loading;
  var onClick = props.onClick;
  var fullWidth = props.fullWidth;

  return (
    <Button
      type={type}
      variant="contained"
      disableElevation
      disabled={disabled || loading}
      onClick={onClick}
      fullWidth={fullWidth}
      sx={{
        fontFamily: AUTH_FONT,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: 1.2,
        textTransform: "none",
        minHeight: 40,
        minWidth: 96,
        px: 2,
        py: 1,
        borderRadius: "6px",
        bgcolor: AUTH_COLORS.primary,
        color: AUTH_COLORS.buttonLabel,
        "&:hover": {
          bgcolor: AUTH_COLORS.primaryHover,
        },
        "&.Mui-disabled": {
          bgcolor: AUTH_COLORS.primary,
          color: AUTH_COLORS.buttonLabel,
          opacity: 0.55,
        },
      }}
    >
      {loading ? (
        <CircularProgress size={18} sx={{ color: AUTH_COLORS.buttonLabel }} />
      ) : (
        children
      )}
    </Button>
  );
}

export default AuthPrimaryButton;
